import HtmlContent from './HtmlContent';

export default HtmlContent;
export { HtmlContent };
